export const participantsQueryKeys = {
	all: ["participants"] as const,
	lists: () => [...participantsQueryKeys.all, "list"] as const,
	list: (filters: Record<string, unknown>) =>
		[...participantsQueryKeys.lists(), { filters }] as const,
	details: () => [...participantsQueryKeys.all, "detail"] as const,
	detail: (id: number) => [...participantsQueryKeys.details(), id] as const,
} as const;
